interface Translation {
  word: string
  description: string
}

const wordTranslation = {
  list: [] as Translation[],

  init: (): void => {
    const articlePage = document.querySelector('.article')

    if (articlePage != null) {
      wordTranslation.fetchData()
    }
  },

  fetchData: async (): Promise<void> => {
    fetch(`/Umbraco/Surface/Content/MolarTranslations`)
      .then((response) => response.json())
      .then((data) => {
        if (data.success === true) {
          Object.entries(data.data).forEach(([key, value]) => {
            wordTranslation.list.push({
              word: key,
              description: value.toString(),
            })
          })
          const testList = wordTranslation.list.filter((item) => item.word !== 'Ófrísk')
          wordTranslation.translate(testList)
        }
      })
  },

  addTooltipListener(element) {
    element.addEventListener('mouseenter', (event) => {
      const tooltipParentRect = event.currentTarget.getBoundingClientRect()
      const containerParentRect = event.currentTarget.parentElement.getBoundingClientRect()
      const tooltipRect = event.currentTarget.getBoundingClientRect()
      const containerRect = event.currentTarget.parentElement.getBoundingClientRect()
      const distanceToContainerBottom = containerParentRect.bottom - tooltipParentRect.bottom
      const distanceToContainerLeft = tooltipRect.left - containerRect.left
      const distanceToContainerRight = containerRect.right - tooltipRect.right
      const threshold = 90
      if (distanceToContainerBottom < 55) {
        event.currentTarget.classList.add('bottom-close')
      } else {
        event.currentTarget.classList.remove('bottom-close')
      }
      if (distanceToContainerLeft <= threshold) {
        event.currentTarget.classList.add('left-close')
      } else {
        event.currentTarget.classList.remove('left-close')
      }

      if (distanceToContainerRight <= threshold) {
        event.currentTarget.classList.add('right-close')
      } else {
        event.currentTarget.classList.remove('right-close')
      }
    })
  },

  createWordTranslationElement(word, description) {
    // Create the outer span
    const wordSpan = document.createElement('span')
    wordSpan.className = 'wordTranslation'

    // Create the inner span for the tooltip text
    const tooltipSpan = document.createElement('span')
    tooltipSpan.className = 'wordTranslation__text'
    tooltipSpan.textContent = description

    // Append the tooltip span to the word span
    wordSpan.appendChild(document.createTextNode(word))
    wordSpan.appendChild(tooltipSpan)

    // Attach the tooltip listener
    this.addTooltipListener(wordSpan)

    return wordSpan
  },

  replaceMatchingWords(pattern: RegExp, description: string): string {
    return description.replace(pattern, (matchedWord) => {
      const matchingItem = wordTranslation.list.find((item) => item.word === matchedWord.toLowerCase())

      const innerHtml =
        '$1<span class="wordTranslation">$2<span class="wordTranslation__text">' + description + '</span></span>$3'

      if (matchingItem) {
        return innerHtml
      } else {
        return matchedWord
      }
    })
  },

  translateTest: (descriptionList: Translation[]): void => {
    const pElements = document.getElementsByTagName('p')
    for (let x = pElements.length; x--; ) {
      const currentElement = pElements[x]

      for (let i = 0, l = descriptionList.length; i < l; i++) {
        const reg = new RegExp('([^a-zA-Z-])(' + descriptionList[i].word + ')([^a-zA-Z-])', 'giu')

        const pattern = new RegExp(descriptionList.map((item) => item.word).join('|'), 'i')
        const patternTest = pattern.test(descriptionList[i].description)

        currentElement.innerHTML = currentElement.innerHTML.replace(
          reg,
          '$1<span class="wordTranslation">$2<span class="wordTranslation__text">' +
            descriptionList[i].description +
            '</span></span>$3'
        )

        if (patternTest === true) {
          const hh = wordTranslation.replaceMatchingWords(pattern, descriptionList[i].description)
          const infoBox = currentElement.querySelectorAll('.wordTranslation__text')

          if (infoBox && infoBox.length && infoBox.length > 1) {
            infoBox[0].innerHTML = hh
          }
        }
      }
    }

    const liElements = document.querySelectorAll('.article__content li')

    if (liElements !== null) {
      for (let y = liElements.length; y--; ) {
        const currentLiElement = liElements[y]

        for (let j = 0, le = descriptionList.length; j < le; j++) {
          const regExpression = new RegExp('([^a-zA-Z-])(' + descriptionList[j].word + ')([^a-zA-Z-])', 'giu')

          currentLiElement.innerHTML = currentLiElement.innerHTML.replace(
            regExpression,
            '$1<span class="wordTranslation">$2<span class="wordTranslation__text">' +
              descriptionList[j].description +
              '</span></span>$3'
          )
        }
      }
    }
  },

  translate: (descriptionList: Translation[]): void => {
    const elements = document.querySelectorAll('.article__content p, .article__content li')

    elements.forEach((element) => {
      descriptionList.forEach((description) => {
        const regex = new RegExp(`(^|[^a-zA-Z-])(${description.word})([^a-zA-Z-]|$)`, 'giu')
        element.childNodes.forEach((child) => {
          if (child.nodeType === 3) {
            // Node type 3 is a text node
            const newContent = []
            child.textContent.split(regex).forEach((part, index) => {
              if (index % 4 === 2) {
                // The word to be translated
                newContent.push(wordTranslation.createWordTranslationElement(part, description.description))
              } else if (part) {
                newContent.push(document.createTextNode(part))
              }
            })
            if (newContent.length) {
              newContent.forEach((newNode) => child.parentNode.insertBefore(newNode, child))
              child.parentNode.removeChild(child)
            }
          }
        })
      })
    })
  },
}

export default wordTranslation
